<template>
  <div ref="head_links" class="head_links">
    <div class="head-flex">
      <template v-for="link of links">
        <HeadLink
          v-if="!link.separator"
          :key="link.name"
          :data-head-link="link.name"
          :headerLinkTarget="headerLinkTarget"
          :link="link"
          @click="handlerCLick"
        />
        <div v-else :key="link.name" class="separator" />
      </template>
    </div>
  </div>
</template>

<script>
import HeadLink from './HeadLink'

export default {
  name: 'HeadLinks',
  components: {
    HeadLink
  },
  props: {
    /**
     * link - String
     * name - String
     * links - links[]
     */
    links: Array,
    headerLinkTarget: String,
    logActionEvent: {
      type: Function,
      default: () => {}
    },
  },
  methods: {
    handlerCLick (link) {
      if (link.eventName) {
        this.logActionEvent(link.eventName)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$header-height: 64px;

.head_links {
  height: 100%;
}

.separator {
  height: 37px;
  margin: auto 0;
  border-left: 1px solid #EAEAEA;
  @media (max-width: 1279px) {
    display: none;
  }
}

.green-link {
  ::v-deep a {
    position: relative;
    color: #00AFA1!important;
    padding-right: 30px!important;
    &:before {
      content: '';
      position: absolute;
      right: 15px;
      top: 50%;
      width: 6px;
      height: 6px;
      margin-top: -4.5px;
      border-top: 2px solid #00AFA1;
      border-left: 2px solid #00AFA1;
      transform: rotate(135deg);
    }
  }
}

.head-flex {
  display: flex;
  flex: 1;
  flex-direction: row;
  flex-wrap: nowrap;
}

.head-flex-item {
  flex: 1;
}

.head-flex-auto {
  flex: 0 0 auto;
}

.link-group__inner {
  position: absolute;
  width: 100%;
  left: 0;
  top: 100%;
  display: flex;
  justify-content: center;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: -100vw;
    z-index: -1;
    width: 200vw;
    height: 100%;
    background-color: $white-color;
    box-shadow: 0 5px 40px 0 rgba(0, 0, 0, 0.03);
  }
}
</style>
